import { render, staticRenderFns } from "./Demanda.vue?vue&type=template&id=eb8a2c4a&scoped=true&"
import script from "./Demanda.vue?vue&type=script&lang=js&"
export * from "./Demanda.vue?vue&type=script&lang=js&"
import style0 from "./Demanda.vue?vue&type=style&index=0&id=eb8a2c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8a2c4a",
  null
  
)

export default component.exports